import React from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import { Card, CardHeader, CardContent } from '../components/ui/Card';
import Badge from '../components/ui/Badge';
import { Shield, FileText } from 'lucide-react';

export default function KycPage() {
  const { data: kyc } = useQuery({ queryKey: ['kycStatus'], queryFn: () => api.get('/kyc/status').then(r => r.data) });

  return (
    <div className="max-w-lg mx-auto space-y-6 animate-fade-in">
      <div className="d-page-header">
        <h1 className="text-2xl font-bold text-white">KYC Verification</h1>
        <p className="text-slate-400 mt-1">Complete verification to unlock all features.</p>
      </div>

      <Card>
        <CardHeader><h2 className="text-base font-semibold text-white">Verification Status</h2></CardHeader>
        <CardContent>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-12 h-12 rounded-xl bg-primary-600/10 flex items-center justify-center">
              <Shield className="w-6 h-6 text-primary-400" />
            </div>
            <div>
              <p className="font-medium text-white">KYC Status</p>
              <Badge status={kyc?.status || 'NOT_SUBMITTED'} />
            </div>
          </div>
          <p className="text-sm text-slate-400">Complete your KYC verification to unlock all platform features including withdrawals.</p>
        </CardContent>
      </Card>

      <Card>
        <CardHeader><h2 className="text-base font-semibold text-white">Uploaded Documents</h2></CardHeader>
        <CardContent>
          {kyc?.documents?.length === 0 ? (
            <p className="text-sm text-slate-500">No documents uploaded yet.</p>
          ) : (
            <div className="space-y-2">
              {kyc?.documents?.map((doc: any) => (
                <div key={doc.id} className="flex items-center justify-between p-3.5 rounded-xl bg-white/[0.02] border border-white/[0.04]">
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-lg bg-white/[0.04] flex items-center justify-center">
                      <FileText className="w-4 h-4 text-slate-400" />
                    </div>
                    <div>
                      <p className="font-medium text-sm text-white">{doc.type}</p>
                      <p className="text-xs text-slate-500">{doc.fileName}</p>
                    </div>
                  </div>
                  <Badge status={doc.status} />
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
